import { getTranslationValue } from '../constants/posMenu';

/**
 * Options of the selected source modifier groups, one entry per option.
 * An option shared by several source groups gets a single nested group,
 * so it's listed once with all of its group names.
 */
export const getUniqueSourceOptions = (sourceMgIds, modifierGroupsMap) => {
  const byOption = new Map();
  (sourceMgIds || []).forEach((mgId) => {
    const mg = modifierGroupsMap?.[mgId];
    const mgName = getTranslationValue(mg?.name) || 'MG';
    (mg?.optionIds || []).forEach((optId) => {
      const entry = byOption.get(optId);
      if (entry) {
        entry.mgNames.push(mgName);
      } else {
        byOption.set(optId, { optId, mgNames: [mgName] });
      }
    });
  });
  return [...byOption.values()];
};
